module.exports = __webpack_public_path__ + "img/panama.09cc2fb2.jpg";